package gr.tech.site.styles

import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

val BlogPreviewCardStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .border(1.px, LineStyle.Solid, Theme.MediumGreen.rgb)
            .borderRadius(8.px)
            .overflow(Overflow.Hidden)
            .backgroundColor(Theme.LightGray.rgb)
            .transition(Transition.all(250.ms))
    }
    hover {
        Modifier
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 12.px,
                spreadRadius = 0.px,
                color = rgba(0, 0, 0, 0.1)
            )
            .translateY((-2).px)
    }
}
